import type { JSX } from "react";
import { memo } from "react";
import clsx from "clsx";

import styles from "./styles.module.scss";

import type { IPaginationLinkProps } from "@components/molecules/pagination/types";

export const PaginationLink = memo(function PaginationLink({
  className,
  isActive,
  // size = 'icon',
  ...props
}: IPaginationLinkProps): JSX.Element {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      aria-current={isActive ? "page" : undefined}
      className={clsx(className, props.disabled && styles.disabled)}
      {...props}
    />
  );
});
